import axios, { AxiosResponse } from 'axios'
import {
  AdicionaFaturaAtendimentoDto,
  AtualizaFaturaAtendimentoDto,
  AtualizaFaturaAtendimentoDtoValores,
  FaturaAtendimentoView,
  PageResponseFaturaAtendimentoList,
} from './_models'
import { FileDownloadResponse } from 'app/modules/apps/relatorios/relatorio-list/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const FINANCEIRO_URL = `${API_URL}/financeiro`
const FINANCEIRO_ATENDIMENTOS_FATURA_URL = `${FINANCEIRO_URL}/fatura/atendimento`
const FINANCEIRO_ATENDIMENTOS_FATURA_EMPRESA_URL = `${FINANCEIRO_URL}/fatura/empresa/atendimento`
const FATURA_RELATORIO_ATENDIMENTOS_URL = `${FINANCEIRO_URL}/fatura/relatorio`

/**
 * Busca atendimentos de uma fatura
 * @param idFatura ID da Fatura
 * @param query string
 * @returns PageResponseFaturaAtendimentoList
 */
export const getAtendimentosByFatura = (
  idFatura: number,
  query: string
): Promise<PageResponseFaturaAtendimentoList> => {
  return axios
    .get(`${FINANCEIRO_ATENDIMENTOS_FATURA_URL}/${idFatura}?${query}`)
    .then((resp: AxiosResponse<PageResponseFaturaAtendimentoList>) => resp.data)
}

/**
 * Adiciona item na fatura
 * @param idFatura ID da Fatura
 * @param data AdicionaFaturaAtendimentoDto
 * @returns FaturaAtendimentoView
 */
export const adicionarItemFatura = (
  idFatura: number,
  data: AdicionaFaturaAtendimentoDto
): Promise<FaturaAtendimentoView> => {
  return axios
    .post(`${FINANCEIRO_ATENDIMENTOS_FATURA_URL}/${idFatura}`, data)
    .then((resp: AxiosResponse<FaturaAtendimentoView>) => resp.data)
}

/**
 * Remove item da fatura (o item poderá entrar nas próximas faturas)
 * @param idFaturaAtendimento ID do atendimento na fatura
 * @returns FaturaAtendimentoView
 */
export const deleteItemFatura = (idFaturaAtendimento: number): Promise<FaturaAtendimentoView> => {
  return axios
    .delete(`${FINANCEIRO_ATENDIMENTOS_FATURA_URL}/${idFaturaAtendimento}`)
    .then((resp: AxiosResponse<FaturaAtendimentoView>) => resp.data)
}

/**
 * Atualiza item da fatura (ajusta valores)
 * @param idFaturaAtendimento ID do atendimento na fatura
 * @param data AtualizaFaturaAtendimentoDtoValores
 * @returns FaturaAtendimentoView
 */
export const atualizaItemFatura = (
  idFaturaAtendimento: number,
  data: AtualizaFaturaAtendimentoDtoValores
): Promise<FaturaAtendimentoView> => {
  return axios
    .patch(`${FINANCEIRO_ATENDIMENTOS_FATURA_URL}/${idFaturaAtendimento}/atualiza`, data)
    .then((resp: AxiosResponse<FaturaAtendimentoView>) => resp.data)
}

/**
 * Inativa item da fatura (o item não poderá entrar nas próximas faturas)
 * @param idFaturaAtendimento ID do atendimento na fatura
 * @param data AtualizaFaturaAtendimentoDtoValores
 * @returns FaturaAtendimentoView
 */
export const inativaItemFatura = (
  idFaturaAtendimento: number,
  data: AtualizaFaturaAtendimentoDto
): Promise<FaturaAtendimentoView> => {
  return axios
    .patch(`${FINANCEIRO_ATENDIMENTOS_FATURA_URL}/${idFaturaAtendimento}/inativa`, data)
    .then((resp: AxiosResponse<FaturaAtendimentoView>) => resp.data)
}

/**
 * Busca atendimento de uma fatura de cliente
 * @param idFatura ID da Fatura
 * @param idEmpresa ID da empresa
 * @param query string
 * @returns PageResponseFaturaAtendimentoList
 */
export const getAtendimentosByFaturaByEmpresa = (
  idFatura: number,
  idEmpresa: number,
  query: string
): Promise<PageResponseFaturaAtendimentoList> => {
  return axios
    .get(`${FINANCEIRO_ATENDIMENTOS_FATURA_EMPRESA_URL}/${idEmpresa}/${idFatura}?${query}`)
    .then((resp: AxiosResponse<PageResponseFaturaAtendimentoList>) => resp.data)
}

/**
 * Gera relatório em PDF dos atendimentos de uma fatura
 * @param idFatura ID da Fatura
 * @param query string - Opcional
 * @returns FileDownloadResponse
 */
export const getRelatoriosOfAtendimentosByFatura = (
  idFatura: number,
  query?: string
): Promise<FileDownloadResponse> => {
  return axios
    .get(`${FATURA_RELATORIO_ATENDIMENTOS_URL}/${idFatura}/pdf${query ? `?${query}` : ''}`)
    .then((resp: AxiosResponse<FileDownloadResponse>) => resp.data)
}
